"use client";

import React from 'react'
import ScrollContainer from 'react-indiana-drag-scroll'

function ClientScrollContainer({className,children}:{
    className?:string,
    children:JSX.Element|JSX.Element[]
}) {
  return (
    <ScrollContainer className={className}>{children}</ScrollContainer>
  )
}

export default ClientScrollContainer
